import { Component } from '@angular/core';

@Component({
  selector: 'app-hr-payroll-guide',
  templateUrl: './hr-payroll-guide.component.html',
  styleUrls: ['./hr-payroll-guide.component.scss']
})
export class HrPayrollGuideComponent {}
